import { useLexicalComposerContext } from "@lexical/react/LexicalComposerContext"
import { useEffect } from "react"
import {
  $getSelection,
  $isRangeSelection,
  COMMAND_PRIORITY_LOW,
  KEY_ENTER_COMMAND,
} from "lexical"

export function EnterKeyPlugin(): null {
  const [editor] = useLexicalComposerContext()

  useEffect(() => {
    return editor.registerCommand(
      KEY_ENTER_COMMAND,
      (event) => {
        const selection = $getSelection()
        
        if ($isRangeSelection(selection)) {
          // Create a new paragraph but let default behavior handle it
          // The spacing will be controlled by CSS in the editor styles
          return false // Let default paragraph creation happen
        }
        
        return false
      },
      COMMAND_PRIORITY_LOW
    )
  }, [editor])

  return null
}
